import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import { doc, getDoc } from "firebase/firestore";
import myContext from "../../../Context/myContext";
import { fireDB } from "../../../firebase/FirebaseConfig";
import Loader from "../../loader/Loader";
import { useNavigate } from "react-router";

const ProductInfo = () => {
  const navigate = useNavigate();
  const context = useContext(myContext);
  const { loading, setLoading } = context;

  const [product, setProduct] = useState(null);
  const { id } = useParams();

  const getProductData = async () => {
    setLoading(true);
    try {
      const productDoc = await getDoc(doc(fireDB, "products", id));
      setProduct(productDoc.data());
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProductData();
  }, [id]);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="py-5 lg:py-16 bg-light">
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <Loader />
        </div>
      ) : (
        <div className="container">
          <div className="row">
            <div className="col-md-6 mb-4">
              <div
                className="card border-0 shadow-lg"
                style={{
                  height: "500px", // Fixed height
                  backgroundColor: "#cce5ff", // Blue background
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "15px", // Add padding for better visibility
                }}
              >
                <img
                  className="card-img-top img-fluid"
                  style={{
                    cursor: "pointer",
                    height: "300px",
                    objectFit: "contain", //
                    border: "none", // Remove border
                    margin: 0, // Remove margin
                    padding: 0, // Remove padding
                  }}
                  src={product?.productImageUrl}
                  alt={product?.title}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="d-flex flex-column h-100">
                <div className="mb-4">
                  <h2 className="text-2xl font-weight-bold text-primary">
                    {product?.title}
                  </h2>
                  <div className="d-flex align-items-center mb-3">
                    <ul className="list-unstyled d-flex mb-0">
                      {[...Array(5)].map((_, index) => (
                        <li key={index}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-star text-warning me-1"
                            viewBox="0 0 16 16"
                          >
                            <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.565.565 0 0 0-.163-.505L1.71 6.745l4.052-.576a.525.525 0 0 0 .393-.288L8 2.223l1.847 3.658a.525.525 0 0 0 .393.288l4.052.575-2.906 2.77a.565.565 0 0 0-.163.506l.694 3.957-3.686-1.894a.503.503 0 0 0-.461 0z"></path>
                          </svg>
                        </li>
                      ))}
                    </ul>
                    <p className="text-xl font-weight-bold text-primary ms-4 mt-3">
                      {product?.price}
                    </p>
                  </div>
                  <p className="mb-4" style={{ whiteSpace: "pre-wrap" }}>
                    {product?.description}
                  </p>

                  <button
                    className="btn btn-primary w-50 mt-auto"
                    onClick={() => navigate(`/contact`)}
                    type="button"
                  >
                    Enquiry Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ProductInfo;
